import { useUsersByID } from '@opallabs/api'
import { Spacing } from '@opallabs/gem'
import { useWorkspace } from '@opallabs/hooks'
import { Avatar } from '@opallabs/lapidary'
import * as styles from './styles'

export const CollaboratorGroupMemberList = ({
  members,
}: {
  members: Array<{ uuid: string; type: 'user' }>
}) => {
  const currentWorkspace = useWorkspace()
  const userIds = members.map((m) => m.uuid)
  const { data: res } = useUsersByID({
    userIds: userIds,
    filter: {
      workspace_id: [currentWorkspace.uuid],
    },
  })

  return (
    <ul
      className="collaborator-group-member-list"
      css={styles.membersContainer}
    >
      {res &&
        res.map((member) => (
          <li
            key={member.uuid}
            css={styles.details}
            style={{ opacity: member.activeWorkspaceMember ? 1 : 0.5 }}
          >
            <Avatar
              size={Spacing.L}
              src={member.asset?.url}
              fullName={member.name}
            />
            <span>{member.name}</span>
          </li>
        ))}
    </ul>
  )
}
